import PasswordReset from "@/components/ViewProfile/UserDetails/passwordReset.component";
import { Card, CardContent } from "@/shadcn/components/ui/card";
import { UserProfileResponse } from "@/types";
import React from "react";

type AdminDetailsFormProps = {
  initialDetails: UserProfileResponse;
};

// type UserProfileResponse = {
//     id: string;
//     email: string;
//     title: string | null;
//     fullName: string;
//     designation: string;
//     phoneNumber: string;
//     preferredLanguage: string;
//     preferredCommunicationMethods: ("email" | "sms")[];
//     marketingOptIn: boolean;
//     lastLogin: Date | null;
// }

const AdminDetailsForm: React.FC<AdminDetailsFormProps> = ({
  initialDetails,
}) => {
  return (
    <Card className="mx-auto h-fit w-full max-w-4xl p-6 shadow-lg">
      <CardContent className="space-y-4">
        <h2 className="text-xl font-semibold">Admin Profile Details</h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="flex flex-wrap gap-2">
            <strong>Full Name:</strong>
            <div>{initialDetails.fullName || "N/A"}</div>
          </div>
          <div className="flex flex-wrap gap-2">
            <strong>Email:</strong>
            <div>{initialDetails.email || "N/A"}</div>
          </div>
          <div className="flex flex-wrap gap-2">
            <strong>Phone Number:</strong>
            <div>{initialDetails.phoneNumber || "N/A"}</div>
          </div>
        </div>
        <PasswordReset />
      </CardContent>
    </Card>
  );
};

export default AdminDetailsForm;
